package diana.soleil.design.iraniancanadienbazzar.feature.onboarding

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppPageIndicator
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppSelectableCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BrandMark
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.fontFamilyFor
import diana.soleil.design.iraniancanadienbazzar.core.model.Country
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_step_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_city_all_canada
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_city_all_usa
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_country_ca
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_country_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_country_title
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_country_us
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_city_coming_soon
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_city_locating
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_city_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_city_title
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_city_use_location
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_continue
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_done
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_interests_change_later
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_interests_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_interests_title
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_language_line_en
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_language_line_fr
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_language_line_fa
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_language_title
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_next
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_skip
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_slide_community_body
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_slide_community_title
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_slide_discover_body
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_slide_discover_title
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_slide_market_body
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.ob_slide_market_title
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.welcome_app_name
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources.welcome_logo_a11y
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource

/** A selectable metro card on the city step. Labels are resolved (localized) by the host. */
data class OnboardingMetroOption(
    val id: String,
    val label: String,
    val sublabel: String?,
    val enabled: Boolean,
)


/** The wizard's steps, reported to the host for analytics. */
enum class OnboardingStep { Language, Country, City }

/**
 * First-run onboarding wizard: Language → Country (only when more than one is launched) → City.
 * Cut from five steps to two/three on 2026-09-11: the value pager and the Interests step were
 * dropped (interests live in Settings) so a first-time member reaches real businesses in two taps.
 * Stitch designs `32480c49…` (language), `c5b2ddd7…` (country), `0ee5b510…` (city);
 * docs/ONBOARDING_PLAN.md + docs/US_EXPANSION_PLAN.md are the product specs. Navigation-agnostic — the
 * host (AppNavHost) wires controllers and persistence:
 *
 * - [onLanguageSelected] applies the language INSTANTLY (App() rebinds strings; FA flips RTL). The
 *   whole tree recomposes under `key(language)`, which lands back on this screen still on step 0 —
 *   that reset is the feature: the user sees the same screen translated.
 * - Every step past Language is skippable; [onFinish] receives how far the user got. Deep links never
 *   route here — the start-destination gate in AppNavHost only chooses onboarding for a cold first run.
 */
@Composable
fun OnboardingFlowScreen(
    currentLanguage: Language,
    onLanguageSelected: (Language) -> Unit,
    selectedCountry: Country,
    onCountrySelected: (Country) -> Unit,
    /** Countries with a launched metro; when only one, the Country step is skipped entirely. */
    availableCountries: List<Country>,
    metroOptions: List<OnboardingMetroOption>,
    selectedMetroId: String?,
    onMetroSelected: (String?) -> Unit,
    resolveNearestMetro: suspend () -> String?,
    onStepShown: (OnboardingStep) -> Unit,
    onFinish: () -> Unit,
    modifier: Modifier = Modifier,
) {
    var step by remember { mutableStateOf(OnboardingStep.Language) }
    LaunchedEffect(step) { onStepShown(step) }

    Box(
        modifier = modifier
            .fillMaxSize()
            .background(AppTheme.colors.background)
            .safeContentPadding()
            .padding(horizontal = AppTheme.spacing.lg),
        contentAlignment = Alignment.TopCenter,
    ) {
        Column(
            // widthIn BEFORE fillMaxWidth (see WelcomeScreen) so web/desktop keeps a phone-ish column.
            modifier = Modifier
                .widthIn(max = AppTheme.sizes.contentMaxWidthCompact)
                .fillMaxWidth()
                .fillMaxSize(),
        ) {
            // Wizard progress dots — the user can see how many steps remain (was no indicator at all).
            // The Country step is skipped with one launched country — don't count it in the dots.
            val steps = OnboardingStep.entries.filter { it != OnboardingStep.Country || availableCountries.size >= 2 }
            val stepIndex = steps.indexOf(step).coerceAtLeast(0)
            val stepLabel = stringResource(Res.string.ob_step_a11y, stepIndex + 1, steps.size)
            AppPageIndicator(
                pageCount = steps.size,
                currentPage = stepIndex,
                modifier = Modifier
                    .align(Alignment.CenterHorizontally)
                    .padding(vertical = AppTheme.spacing.md)
                    .semantics { contentDescription = stepLabel },
            )
            when (step) {
                OnboardingStep.Language -> LanguageStep(
                    currentLanguage = currentLanguage,
                    onLanguageSelected = onLanguageSelected,
                    onContinue = {
                        // Single launched country (e.g. CA-only launch) → the Country step is
                        // meaningless with one option: lock it in and go straight to City.
                        if (availableCountries.size < 2) {
                            onCountrySelected(availableCountries.first())
                            step = OnboardingStep.City
                        } else {
                            step = OnboardingStep.Country
                        }
                    },
                )
                OnboardingStep.Country -> CountryStep(
                    selectedCountry = selectedCountry,
                    onCountrySelected = onCountrySelected,
                    availableCountries = availableCountries,
                    onContinue = { step = OnboardingStep.City },
                    onBack = { step = OnboardingStep.Language },
                )
                OnboardingStep.City -> CityStep(
                    options = metroOptions,
                    selectedMetroId = selectedMetroId,
                    selectedCountry = selectedCountry,
                    onMetroSelected = onMetroSelected,
                    resolveNearestMetro = resolveNearestMetro,
                    onContinue = onFinish,
                    // Skip back over the (skipped) Country step when there's only one country.
                    onBack = { step = if (availableCountries.size < 2) OnboardingStep.Language else OnboardingStep.Country },
                )
            }
        }
    }
}

// ── Step 0: Language ─────────────────────────────────────────────────────────────────────────────

@Composable
private fun LanguageStep(
    currentLanguage: Language,
    onLanguageSelected: (Language) -> Unit,
    onContinue: () -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Spacer(Modifier.weight(0.6f))
        BrandMark(
            contentDescription = stringResource(Res.string.welcome_logo_a11y),
            modifier = Modifier.size(AppTheme.sizes.brandMark),
        )
        Spacer(Modifier.height(AppTheme.spacing.md))
        Text(
            text = stringResource(Res.string.welcome_app_name),
            style = AppTheme.typography.headlineLg,
            color = AppTheme.colors.primary,
        )
        Spacer(Modifier.height(AppTheme.spacing.xs))
        // One invitation line per language, each in ITS OWN font family: Skia (web) has no per-glyph
        // fallback, so Farsi text inside the Latin theme renders as tofu without vazirmatn.
        listOf(
            Language.EN to stringResource(Res.string.ob_language_line_en),
            Language.FR to stringResource(Res.string.ob_language_line_fr),
            Language.FA to stringResource(Res.string.ob_language_line_fa),
        ).forEach { (language, line) ->
            Text(
                text = line,
                style = AppTheme.typography.bodySm.copy(fontFamily = fontFamilyFor(language)),
                color = AppTheme.colors.onSurfaceVariant,
                textAlign = TextAlign.Center,
            )
        }
        Spacer(Modifier.weight(0.4f))
        Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
            // Endonyms come from the Language enum — a language's own name never translates, and each
            // renders in its own script's family (see the subtitle comment above).
            Language.entries.forEach { language ->
                AppSelectableCard(
                    label = language.endonym,
                    selected = language == currentLanguage,
                    onClick = { if (language != currentLanguage) onLanguageSelected(language) },
                    centered = true,
                    labelStyle = AppTheme.typography.headlineMd.copy(fontFamily = fontFamilyFor(language)),
                )
            }
        }
        Spacer(Modifier.weight(1f))
        AppButton(
            text = stringResource(Res.string.ob_continue),
            onClick = onContinue,
            modifier = Modifier.fillMaxWidth(),
            trailingIcon = "arrow_forward",
        )
        Spacer(Modifier.height(AppTheme.spacing.lg))
    }
}

// ── Step 2: Country ──────────────────────────────────────────────────────────────────────────────

/** Stitch `c5b2ddd7…`. Two big country cards + Continue — the twin of the Language step. */
@Composable
private fun CountryStep(
    selectedCountry: Country,
    onCountrySelected: (Country) -> Unit,
    availableCountries: List<Country>,
    onContinue: () -> Unit,
    onBack: () -> Unit,
) {
    Column(modifier = Modifier.fillMaxSize()) {
        Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.ob_back_a11y),
                onClick = onBack,
            )
        }
        Column(
            modifier = Modifier
                .weight(1f)
                .verticalScroll(rememberScrollState()),
        ) {
            Text(
                text = stringResource(Res.string.ob_country_title),
                style = AppTheme.typography.headlineLgMobile,
                color = AppTheme.colors.onSurface,
            )
            Spacer(Modifier.height(AppTheme.spacing.xs))
            Text(
                text = stringResource(Res.string.ob_country_subtitle),
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Spacer(Modifier.height(AppTheme.spacing.lg))
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                // Flag emoji is baked into the label string (localized) — the card renders a plain label.
                val countryLabels = mapOf(
                    Country.CA to stringResource(Res.string.ob_country_ca),
                    Country.US to stringResource(Res.string.ob_country_us),
                )
                availableCountries.map { it to (countryLabels[it] ?: it.code) }.forEach { (country, label) ->
                    AppSelectableCard(
                        label = label,
                        selected = country == selectedCountry,
                        onClick = { onCountrySelected(country) },
                        modifier = Modifier.fillMaxWidth(),
                    )
                }
            }
        }
        AppButton(
            text = stringResource(Res.string.ob_continue),
            onClick = onContinue,
            modifier = Modifier.fillMaxWidth(),
            trailingIcon = "arrow_forward",
        )
        Spacer(Modifier.height(AppTheme.spacing.lg))
    }
}

// ── Step 3: City ─────────────────────────────────────────────────────────────────────────────────

@Composable
private fun CityStep(
    options: List<OnboardingMetroOption>,
    selectedMetroId: String?,
    selectedCountry: Country,
    onMetroSelected: (String?) -> Unit,
    resolveNearestMetro: suspend () -> String?,
    onContinue: () -> Unit,
    onBack: () -> Unit,
) {
    val scope = rememberCoroutineScope()
    var locating by remember { mutableStateOf(false) }

    Column(modifier = Modifier.fillMaxSize()) {
        Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.ob_back_a11y),
                onClick = onBack,
            )
        }
        Column(
            modifier = Modifier
                .weight(1f)
                .verticalScroll(rememberScrollState()),
        ) {
            Text(
                text = stringResource(Res.string.ob_city_title),
                style = AppTheme.typography.headlineLgMobile,
                color = AppTheme.colors.onSurface,
            )
            Spacer(Modifier.height(AppTheme.spacing.xs))
            Text(
                text = stringResource(Res.string.ob_city_subtitle),
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Spacer(Modifier.height(AppTheme.spacing.lg))
            AppButton(
                text = stringResource(
                    if (locating) Res.string.ob_city_locating else Res.string.ob_city_use_location,
                ),
                onClick = {
                    if (!locating) {
                        locating = true
                        scope.launch {
                            resolveNearestMetro()?.let(onMetroSelected)
                            locating = false
                        }
                    }
                },
                modifier = Modifier.fillMaxWidth(),
                variant = AppButtonVariant.Secondary,
                loading = locating,
                leadingIcon = "my_location",
            )
            Spacer(Modifier.height(AppTheme.spacing.lg))
            val comingSoon = stringResource(Res.string.ob_city_coming_soon)
            options.chunked(2).forEach { rowOptions ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(bottom = AppTheme.spacing.md),
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                ) {
                    rowOptions.forEach { option ->
                        AppSelectableCard(
                            label = option.label,
                            supportingText = option.sublabel,
                            selected = option.id == selectedMetroId,
                            enabled = option.enabled,
                            disabledBadge = comingSoon,
                            onClick = { onMetroSelected(option.id) },
                            modifier = Modifier.weight(1f),
                        )
                    }
                    if (rowOptions.size == 1) Spacer(Modifier.weight(1f))
                }
            }
            AppButton(
                text = stringResource(
                    when (selectedCountry) {
                        Country.US -> Res.string.ob_city_all_usa
                        Country.CA -> Res.string.ob_city_all_canada
                    },
                ),
                onClick = {
                    onMetroSelected(null)
                    onContinue()
                },
                modifier = Modifier.align(Alignment.CenterHorizontally),
                variant = AppButtonVariant.Text,
            )
        }
        AppButton(
            text = stringResource(Res.string.ob_continue),
            onClick = onContinue,
            modifier = Modifier.fillMaxWidth(),
            trailingIcon = "arrow_forward",
        )
        Spacer(Modifier.height(AppTheme.spacing.lg))
    }
}
